(() => {
  const drawer = document.getElementById('hobEnquiryDrawer');
  if (!drawer) return;

  // Drawer form
  const enquiryForm = document.getElementById('hobEnquiryForm'); // matches your Liquid id exactly
  const submitBtn = drawer.querySelector('[data-hob-submit]');
  const bodyEl = drawer.querySelector('[data-hob-body]');

  // Hidden fields in the drawer form
  const variantIdField = document.getElementById('hobSelectedVariantId');
  const variantTitleField = document.getElementById('hobSelectedVariantTitle');

  // Visible product title container in drawer
  const titleEl = document.getElementById('hobEnquiryProductTitle');

  // Notice element (we recommend adding it in Liquid)
  const noticeEl = drawer.querySelector('.hob-enquiry__notice');

  // ----------------------------
  // Helpers
  // ----------------------------
  function setNotice(type, message) {
    if (!noticeEl) return;

    if (!message) {
      noticeEl.hidden = true;
      noticeEl.textContent = '';
      noticeEl.classList.remove('hob-enquiry__notice--success', 'hob-enquiry__notice--error');
      noticeEl.removeAttribute('role');
      return;
    }

    noticeEl.hidden = false;
    noticeEl.textContent = message;
    noticeEl.classList.toggle('hob-enquiry__notice--success', type === 'success');
    noticeEl.classList.toggle('hob-enquiry__notice--error', type === 'error');
    noticeEl.setAttribute('role', type === 'success' ? 'status' : 'alert');
  }

  function setSubmitState(isLoading) {
    if (!submitBtn) return;

    if (isLoading) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent;
      submitBtn.textContent = 'Sending…';
      submitBtn.setAttribute('aria-busy', 'true');
    } else {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.dataset.originalText || 'Submit enquiry';
      submitBtn.removeAttribute('aria-busy');
    }
  }

  // ----------------------------
  // Product context (Prestige-safe)
  // ----------------------------
  function getProductContext() {
    const title =
      drawer?.dataset?.hobProductTitle?.trim() ||
      document.querySelector('.product-meta__title')?.textContent?.trim() ||
      document.querySelector('main h1')?.textContent?.trim() ||
      '';

    const addToCartForm = document.querySelector('form[action="/cart/add"]');
    let variantId = '';

    if (addToCartForm) {
      const idInput = addToCartForm.querySelector('input[name="id"]');
      if (idInput) variantId = idInput.value;
    }

    return { title, variantId };
  }

  // ----------------------------
  // Drawer open/close
  // ----------------------------
  function openDrawer() {
    const ctx = getProductContext();

    // Hidden fields (submission context)
    if (variantIdField) variantIdField.value = ctx.variantId || '';
    if (variantTitleField) variantTitleField.value = ctx.title || '';

    // Visible display
    if (titleEl) titleEl.textContent = ctx.title || '';

    // Clear state
    setNotice('', '');
    setSubmitState(false);

    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ----------------------------
  // Trigger binding
  // ----------------------------
  function bindTriggers() {
    // Prestige button link set to #hob-enquiry
    document.querySelectorAll('a[href$="#hob-enquiry"], a[href="#hob-enquiry"]').forEach(a => {
      if (a.dataset.hobBound === 'true') return;
      a.dataset.hobBound = 'true';

      a.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
      });
    });

    // Optional: custom trigger
    document.querySelectorAll('[data-hob-enquiry-open]').forEach(el => {
      if (el.dataset.hobBound === 'true') return;
      el.dataset.hobBound = 'true';

      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      });
    });
  }

  // Close buttons + overlay
  drawer.querySelectorAll('[data-hob-close]').forEach(el => {
    el.addEventListener('click', closeDrawer);
  });

  // Escape closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  // Bind triggers now + after section re-render
  bindTriggers();
  setTimeout(bindTriggers, 800);

  // ----------------------------
  // Native submit UX (no AJAX)
  // ----------------------------
  if (enquiryForm) {
    enquiryForm.addEventListener('submit', () => {
      // Let Shopify handle captcha/challenge + submission
      setSubmitState(true);
    });
  }

  // ----------------------------
  // Success state after return_to redirect
  // ----------------------------
  try {
    const url = new URL(window.location.href);
    const success = url.searchParams.get('hob_enquiry') === 'success';

    if (success) {
      openDrawer();

      drawer.classList.add('hob-enquiry--success-only');
      // Hide the form body so only header + success notice remain
      if (bodyEl) bodyEl.hidden = true;

      setNotice('success', "Thank you for your enquiry. We’ll be in touch soon.");
      
        // If success message exists, the drawer is open on load; close it after a delay
        setTimeout(() => {
            closeDrawer();

            // restore for next open
            if (bodyEl) bodyEl.hidden = false;
            drawer.classList.remove('hob-enquiry--success-only');
             // clean URL (remove success param + hash)
            const url = new URL(window.location.href);
            url.searchParams.delete('hob_enquiry');
            if (url.hash === '#hob-enquiry') url.hash = '';
            history.replaceState(null, '', url.pathname + (url.search ? url.search : '') + url.hash);
        }, 3000); // 3s feels good; change as you like
    }
  } catch (e) {}

  // ----------------------------
  // Reduced motion support
  // ----------------------------
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const panel = drawer.querySelector('.hob-enquiry__panel');
    const overlay = drawer.querySelector('.hob-enquiry__overlay');
    if (panel) panel.style.transition = 'none';
    if (overlay) overlay.style.transition = 'none';
  }

})();
